import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React from "reactn";
import styled from "styled-components";

export const NavButtons = ({ onPrev, onNext, loading }) => {
	return (
		<>
			{onPrev && (
				<Button
					onClick={onPrev}
					shape="round"
					icon={<LeftOutlined />}
					size="large"
				>
					{" "}
					Anterior{" "}
				</Button>
			)}
			{onNext && (
				<Button
					type="primary"
					onClick={onNext}
					shape="round"
					icon={<RightOutlined />}
					size="large"
					loading={loading}
				>
					{" "}
					Siguiente{" "}
				</Button>
			)}
		</>
	);
};

/*
export const NavButton = ({stroke = "#4a90e2", fill = "#fff", onClick, label, disabled, loading, left}) => {
	return (
		<Button onClick={onClick} stroke={stroke} fill={fill} left={left}>
			{label}
			<Icon type={left ? Icons.left : Icons.right} size={1} />
		</Button>
	);
};

const Button = styled.div`
	cursor: pointer;
	border-radius: 15px;
	border-style: solid;
	border-width: 1px;
	border-color: ${ p => p.stroke};
	background-color: ${p => p.fill};
	background-image: url(${p => p.icon});
	background-position: ${p => p.left ? "5" : "-5"}%;
	font-weight: 600;
	color: ${ p => p.stroke};
	padding: 5px 0 5px 0;
	text-align: center;
	width: 100%;
	position: relative;

	svg {
		position: absolute;
		left: 22px;
		top: 9px;
	}

	@media screen and (min-width: 767px) {
		& {
		}
	}
`;
*/
